import { render, staticRenderFns } from "./VvTips.vue?vue&type=template&id=73d1e850&scoped=true&"
import script from "./VvTips.vue?vue&type=script&lang=js&"
export * from "./VvTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d1e850",
  null
  
)

export default component.exports